import { apiCall } from "./authServices";

export const GetMvrMoM = async ({payload}) => {
    try {
        const endpoint = `api/dashboard/mvr-mom-data`
        const res = await apiCall({endpoint: endpoint, method : 'post', payload: payload});
        return res.data;
    } catch (error) {
        throw error;
    }
};


export const GetEscalationData = async ({payload}) => {
    try {
        const endpoint = `api/dashboard/get-mom-escalation-form-data`
        const res = await apiCall({endpoint: endpoint, method : 'post', payload: payload});
        return res.data;
    } catch (error) {
        throw error;
    }
}

export const GetEscalationDays = async () => {
    try{
        const endpoint = "api/dashboard/get-mom-escalation-days"
        const res = await apiCall({
            endpoint: endpoint,
            method: "GET"
        })
        return res;
    }catch(error){
        throw error;
    }
}


// bmvr
// bmvr
// bmvr
// bmvr
// bmvr
// bmvr
export const GetBmvrMoM = async ({payload}) => {
    try{
        const endpoint = `api/dashboard/bmvr/bmvr-mom-data`
        const res = await apiCall({
            endpoint: endpoint,
            method: "POST",
            payload: payload,
        })
        return res;
    }catch(error){
        throw error;
    }
}

export const GetBmvrMoMEscalationData = async ({payload}) => {
    try {
        const endpoint = `api/dashboard/bmvr/bmvr-get-mom-escalation-form-data`
        const res = await apiCall({endpoint: endpoint, method : 'post', payload: payload});
        return res.data;
    } catch (error) {
        throw error;
    }
}